export const SUPPLIER_NONE_VALUE = 'none';

export const SUPPLIER_NONE_OPTION = {
  value: SUPPLIER_NONE_VALUE,
  name: 'Sans fournisseur',
};

export const COMPANY_SUPPLIER_NONE_VALUE = '';
export const COMPANY_SUPPLIER_NONE_LABEL = 'Aucun fournisseur';

export const buildCompanySupplierFormOptions = (suppliers = []) => [
  { value: COMPANY_SUPPLIER_NONE_VALUE, label: COMPANY_SUPPLIER_NONE_LABEL },
  ...suppliers.map((supplier) => ({
    value: String(supplier._id),
    label: supplier.name,
  })),
];

export const parseSupplierSearchParam = (supplierParam) => {
  if (!supplierParam) return [];
  return supplierParam.split(',').filter(Boolean);
};

export const migrateSavedSupplierSearch = (saved = {}) =>
  Array.isArray(saved.supplierSearch) ? saved.supplierSearch : [];

export const isValidSupplierSearchValue = (value, supplierIds = []) =>
  value === SUPPLIER_NONE_VALUE || supplierIds.includes(String(value));

export const buildSupplierFilterOptions = (suppliers = []) => [
  ...suppliers.map((supplier) => ({
    value: String(supplier._id),
    name: supplier.name,
  })),
  SUPPLIER_NONE_OPTION,
];

export const getSupplierFilterLabel = (selected = [], suppliers = []) => {
  if (selected.length === 0) return 'Fournisseur';

  const options = buildSupplierFilterOptions(suppliers);
  return options
    .filter((option) => selected.includes(option.value))
    .map((option) => option.name)
    .join(', ');
};
